var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManBeard1A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type3_x5F_beards"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x36_",
    fill: "#862618",
    d: "M360.5,372.5c3.2,0,9-0.2,12.2-0.1c3.7,0.1,3.9-0.3,4.1,3.1c0.1,2.2,0.2,2.8-0.8,4.1 c-2,2.4-5.3,4.5-6.8,5.6c-0.5,0.4-3,2-3.5,2.3c3.4,3.2,5.7,8.1,11.8,8.4c5,0.3,9.4,0,13.7-2.3c4.5-2.3,10-5.8,14.8-9.1 c2.6-1.8,8.2-5.6,10-6.8c2-1.4,6.5-3.5,7.3-2.7c-2.4,2.9-4.3,6.7-7.5,10.5c-4.5,5.4-10.5,10.8-14.7,14.3 c-7.5,6.2-19.4,15.2-29.3,15.7c-11.7,0.6-21.8,1.2-32.3-4.3c-8.7-4.5-16.8-10.7-24.6-16.5c-4-3-7.5-6.1-11.6-9.6 c-2-1.7-10.1-12-9.6-12.1c0.8-0.1,9.1,5.5,11.1,6.6c8.3,4.6,15.4,9,24.3,12.7c4.7,1.9,11.7,4.2,16.9,2.6c2.4-0.7,4.2-2.1,5.9-3.7 c0.8-0.8,3.1-3,3.4-4c0,0-0.4-0.3-2-1.6c-2.6-2.2-7.2-4.4-8.6-7.1c-0.8-1.7-0.9-4.5,0.4-5.3c0.8-0.5,4.9-0.4,5.9-0.4 c2.9-0.1,6.3-0.1,7.3-0.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBeard1A);
export default __webpack_public_path__ + "static/media/man_beard_1a.d6e389d5c828a6acf2b8db5984cd9f96.svg";
export { ForwardRef as ReactComponent };